export const name = "IS_INF";
export const summary = `Checks if \`X\` is positive or negative infinity.`;
export const reference = `
## IS_INF

Checks if \`X\` is positive or negative infinity.

\`\`\`
IS_INF(X)
\`\`\`

### Description

Returns \`TRUE\` if the value is positive or negative infinity.

| X | IS\\_INF(X) |
| --- | --- |
| \`+inf\` | \`TRUE\` |
| \`-inf\` | \`TRUE\` |
| 25 | \`FALSE\` |


source: https://cloud.google.com/bigquery/docs/reference/standard-sql/mathematical_functions
`;
